import { render, staticRenderFns } from "./Waiters.vue?vue&type=template&id=84dd3048&scoped=true&lang=pug"
import script from "./Waiters.vue?vue&type=script&lang=ts"
export * from "./Waiters.vue?vue&type=script&lang=ts"
import style0 from "./Waiters.vue?vue&type=style&index=0&id=84dd3048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dd3048",
  null
  
)

export default component.exports